export default `
precision highp float;

varying vec2 vUv;
uniform sampler2D depth;
uniform sampler2D noise;
uniform vec2 noiseUvScaler;
uniform float time;

void main() {
	vec4 depthColor = texture2D(depth, vUv);

	if (depthColor.a <= 0.0) {
		gl_FragColor = vec4(0.0);
		return;
	}

	float bakedInNoise = depthColor.g;

	vec2 uv = vec2(vUv.x * noiseUvScaler.x, vUv.y * noiseUvScaler.y);
	float offset = time;
	vec4 noiseColor = texture2D(noise, uv + vec2(offset));
	//vec4 noiseColor = texture2D(noise, uv);
	float addedNoise = noiseColor.r;

	float newNoise = bakedInNoise + addedNoise;
	normalize(newNoise);
	depthColor.g = max(newNoise, 0.01); //dont allow straight 0, because it signals trails that this is a virus if blue channel value is set
	
	gl_FragColor = depthColor;
}
`